import { render, staticRenderFns } from "./point-detail.vue?vue&type=template&id=6953f93b&scoped=true"
import script from "./point-detail.vue?vue&type=script&lang=js"
export * from "./point-detail.vue?vue&type=script&lang=js"
import style0 from "./point-detail.vue?vue&type=style&index=0&id=6953f93b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6953f93b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/apps/wpms/web/wind-plannerDev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6953f93b')) {
      api.createRecord('6953f93b', component.options)
    } else {
      api.reload('6953f93b', component.options)
    }
    module.hot.accept("./point-detail.vue?vue&type=template&id=6953f93b&scoped=true", function () {
      api.rerender('6953f93b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/components/point-detail.vue"
export default component.exports